<template>
  <i-bi-telephone />
</template>
